module.exports = __webpack_public_path__ + "static/media/grayscale.11badc7d.jpg";